import {
  // existing
  SET_USER_APPOINTMENTS,
  SET_USER_APPOINTMENTS_LOADING,
  SET_USER_APPOINTMENTS_LOADED,
  RESET_USER_APPOINTMENTS,
  // new
  SET_HOME_SERVICES,
  SET_HOME_STAFF,
  SET_HOME_DATE_NOW,
  SET_HOME_LOADING,
  SET_HOME_LOADED,
  RESET_HOME,
} from "../../action/user/appointments/type";

const initialState = {
  // appointments part
  appointments: [],
  loading: false,
  loaded: false,

  // home data part
  services: [],
  staff: [],
  dateNowServer: null,
  homeLoading: false,
  homeLoaded: false,
};

const userAppointmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- appointments cases ---
    case SET_USER_APPOINTMENTS:
      return { ...state, appointments: action.payload };
    case SET_USER_APPOINTMENTS_LOADING:
      return { ...state, loading: action.payload };
    case SET_USER_APPOINTMENTS_LOADED:
      return { ...state, loaded: action.payload };
    case RESET_USER_APPOINTMENTS:
      return {
        ...state,
        appointments: [],
        loading: false,
        loaded: false,
      };

    // --- home data cases ---
    case SET_HOME_SERVICES:
      return { ...state, services: action.payload };
    case SET_HOME_STAFF:
      return { ...state, staff: action.payload };
    case SET_HOME_DATE_NOW:
      return { ...state, dateNowServer: action.payload };
    case SET_HOME_LOADING:
      return { ...state, homeLoading: action.payload };
    case SET_HOME_LOADED:
      return { ...state, homeLoaded: action.payload };
    case RESET_HOME:
      return {
        ...state,
        services: [],
        staff: [],
        dateNowServer: null,
        homeLoading: false,
        homeLoaded: false,
      };

    default:
      return state;
  }
};

export default userAppointmentsReducer;